"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Callback = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Callback = ({ tokenService, silent, }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    silent
        ? tokenService.signinSilentCallback()
        : tokenService.signinRedirectCallback().then((user) => {
            if (!user) {
                window.close();
                return;
            }
            const backUrl = user.state && user.state['url'];
            if (!backUrl) {
                window.close();
            }
            navigate(`${backUrl}${user.state['search'] ?? ''}`, {
                state: user.state
            });
        });
    return react_1.default.createElement("div", { key: "spinner", className: "spinner-border", role: "status" });
};
exports.Callback = Callback;
